module.exports = __webpack_public_path__ + "static/full3-a0479695839e219530b5df94e591a380.png";